import { useState, useEffect, useMemo } from 'react';
import { getSymbols } from '../../services/SymbolsService';
import SelectQuote, { filterSymbolNames, getDefaultQuote } from '../../components/SelectQuote';

function BookCard(props) {
    const [allSymbols, setAllSymbols] = useState([]);
    const [quote, setQuote] = useState(getDefaultQuote());

    function onQuoteChange(event) {
        setQuote(event.target.value);
    }

    useEffect(() => {
        getSymbols(false)
            .then((symbols) => setAllSymbols(filterSymbolNames(symbols.rows, quote)))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
            })
    }, [quote]);

    const sortedSymbols = useMemo(() => {
        if (!allSymbols || allSymbols.length === 0) return [];
        
        return [...allSymbols].sort((a, b) => {
            const hasDataA = props.data[a] && (
                (props.data[a].bestBid !== undefined && props.data[a].bestBid !== '0' && props.data[a].bestBid !== 0) ||
                (props.data[a].bestAsk !== undefined && props.data[a].bestAsk !== '0' && props.data[a].bestAsk !== 0)
            );
            const hasDataB = props.data[b] && (
                (props.data[b].bestBid !== undefined && props.data[b].bestBid !== '0' && props.data[b].bestBid !== 0) ||
                (props.data[b].bestAsk !== undefined && props.data[b].bestAsk !== '0' && props.data[b].bestAsk !== 0)
            );
            
            if (hasDataA === hasDataB) {
                return a.localeCompare(b);
            }
            if (hasDataA && !hasDataB) return -1;
            return 1;
        }).slice(0, 10); // Limita a 10 itens
    }, [allSymbols, props.data]);

    function formatPrice(price) {
        if (!price || price === '0') return '-';
        return parseFloat(price).toFixed(8).substring(0, 10);
    }

    return (
        <div className="dashboard-card">
            <div className="dashboard-card-header">
                <h3 className="dashboard-card-title">Livro de Ordens</h3>
                <SelectQuote onChange={onQuoteChange} value={quote} />
            </div>
            <div className="dashboard-card-content">
                {sortedSymbols && sortedSymbols.length > 0 ? (
                    sortedSymbols.map(symbol => {
                        const bookData = props.data[symbol];
                        if (!bookData) return null;
                        
                        return (
                            <div key={symbol} className="dashboard-card-item">
                                <div className="dashboard-card-item-symbol">{symbol}</div>
                                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                    <div style={{ textAlign: 'right' }}>
                                        <div className="dashboard-card-item-value" style={{ color: '#4caf50' }}>
                                            {formatPrice(bookData.bestBid)}
                                        </div>
                                        <div style={{ fontSize: '0.7rem', color: '#a0a0a0' }}>Compra</div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div className="dashboard-card-item-value" style={{ color: '#f44336' }}>
                                            {formatPrice(bookData.bestAsk)}
                                        </div>
                                        <div style={{ fontSize: '0.7rem', color: '#a0a0a0' }}>Venda</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="dashboard-card-empty">Nenhum dado disponível</div>
                )}
            </div>
        </div>
    );
}

export default BookCard;














